const initialState = {
    uploadAttendanceFileData: [],
    isUploadingAttendanceFile: false,
};

const AttendanceReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_UPLOAD_ATTENDANCE_FILE":
            return { ...state, isUploadingAttendanceFile: true };
        case "SUCCESS_UPLOAD_ATTENDANCE_FILE":
            return { ...state, uploadAttendanceFileData: action.payload, isUploadingAttendanceFile: false };
        case "ERROR_UPLOAD_ATTENDANCE_FILE":
            return { ...state, isUploadingAttendanceFile: false };



        default:
            return state;
    }
}

export default AttendanceReducer;